
export const LOGIN_PATH = `/login`;
export const LOGOUT_PATH = `/logout`;


export const BROWSER_PATH = `/browser`;

export const DASHBOARD_PATH = '/dashboard'

export const TEMPLATE_PATH = `/template`;
export const TEMPLATE_BROWSER_PATH = `${TEMPLATE_PATH}${BROWSER_PATH}`;
export const INITITATE_DTL_TEMPLATE_PATH = `${TEMPLATE_BROWSER_PATH}/inititate`;
export const MANAGE_TEMPLATE_PATH = `${TEMPLATE_BROWSER_PATH}/manage`;
export const CLONE_TEMPLATE_PATH = `${TEMPLATE_BROWSER_PATH}/clone`;

export const SITE_DTL_PATH = `/sitedtl`;
export const SITE_DTL_BROWSER_PATH = `${SITE_DTL_PATH}${BROWSER_PATH}`;
export const MANAGE_SITE_DTL_PATH = `${SITE_DTL_BROWSER_PATH}/manage`;
export const CLONE_SITE_DTL_PATH = `${SITE_DTL_PATH}/clone`;
export const APPROVAL_SITE_DTL_PATH = `${SITE_DTL_PATH}/approve`;
export const SUBMIT_SITE_DTL_PATH = `${SITE_DTL_PATH}/submit`;
export const UPCOMING_DTL_PATH = `${SITE_DTL_PATH}/upcoming`;
export const REQUEST_CLONE_CONFIRMATION_PATH = `${CLONE_SITE_DTL_PATH}/confirm`;
export const REQUEST_APPROVE_CONFIRMATION_PATH = `${APPROVAL_SITE_DTL_PATH}/confirm`;
export const REQUEST_SUBMIT_CONFIRMATION_PATH = `${SUBMIT_SITE_DTL_PATH}/confirm`;
export const INITITATE_NEW_DTL_PATH = `${SITE_DTL_BROWSER_PATH}/inititate`;

export const TASK_ASSIGNMENT_PATH = '/task-assignment';
export const TASK_ASSIGNMENT_BROWSER_PATH = `${TASK_ASSIGNMENT_PATH}/browser`;
export const MANAGE_TASKS_PATH = `${TASK_ASSIGNMENT_PATH}/manage`;
export const ASSIGN_TASKS_PATH = `${MANAGE_TASKS_PATH}/assign`;
export const INACTIVATE_TASKS_PATH = `${MANAGE_TASKS_PATH}/inactivate`;
export const REQUEST_ASSIGN_CONFIRMATION_PATH = `${ASSIGN_TASKS_PATH}/confirm`;
export const REQUEST_INACTIVATE_CONFIRMATION_PATH = `${INACTIVATE_TASKS_PATH}/confirm`;

export const MANAGE_TEMPLATE_PATH_PARAM = `${MANAGE_TEMPLATE_PATH}/:guid`;
export const CLONE_TEMPLATE_PATH_PARAM = `${CLONE_TEMPLATE_PATH}/:guid`;
export const MANAGE_SITE_DTL_PATH_PARAM = `${MANAGE_SITE_DTL_PATH}/:guid`;

export const REQUEST_DTL_PATH = `/request`;
export const REQUEST_BROWSER_PATH = `${REQUEST_DTL_PATH}${BROWSER_PATH}`;

export const PROCESS_IDP_REQUEST = `/idprequest`; 
export const DEFAULT_REQUEST = `/default`; 
